import { render, staticRenderFns } from "./Orcamento.vue?vue&type=template&id=325e5864&scoped=true"
import script from "./Orcamento.vue?vue&type=script&lang=js"
export * from "./Orcamento.vue?vue&type=script&lang=js"
import style0 from "./Orcamento.vue?vue&type=style&index=0&id=325e5864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325e5864",
  null
  
)

export default component.exports